import { useMutation } from '@common-fe/common-fe';
import { useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { QUERY_KEY } from '@/modules/employer/hooks/useEmployersList.query';

import { ExpressSetupStatuses } from '../ExpressSetup.types';
import { EXPRESS_SETUP_QUERY_KEY } from '../queries/useGetExpressSetupById.query';

interface Params {
  id?: string;
  status?: ExpressSetupStatuses;
}

export const useUpdateExpressSetupStatusByIdQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    (params?: Params) =>
      api.patch(
        `${API_URL.EXPRESS_SETUPS_STATUS_BY_ORGANIZATION_ID(params?.id || '')}?status=${params?.status}`
      ),
    {
      onSuccess: (_data, params) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
        queryClient.invalidateQueries({
          queryKey: [EXPRESS_SETUP_QUERY_KEY, params?.id],
        });
      },
    }
  );

  const handleSave = async (params?: Params) => {
    await mutateAsync(params);
  };

  return {
    handleSave,
    isLoading,
    isSuccess,
    isError,
  };
};
